export default "__VITE_ASSET__CFhHA1Fk__"